// extracted by mini-css-extract-plugin
export default {"wrapper":"HomePage_wrapper__j55TB","button_wrapper":"HomePage_button_wrapper__mSVkG"};